import { render } from "./setting.vue?vue&type=template&id=48209996"
import script from "./setting.vue?vue&type=script&lang=js"
export * from "./setting.vue?vue&type=script&lang=js"

import exportComponent from "E:\\newwww\\weimj\\agency\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__